__turbopack_context__.v({
  "row": "row-module-scss-module__jHqOUG__row",
});
